import React, { useState, useEffect, useRef } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import property_address from "../images/post-property/property_address.png"
import property_photos from "../images/post-property/property_photos.png"
import property_pricing from "../images/post-property/property_pricing.png"
import vector from "../images/post-property/Vector.png"
import Chatus from '../Components/chatwithus'


function PostProperty ()  {

    useEffect(()=>{
        AOS.init({duration:1000});
      }, [])

    const intailvalues ={
        service:"",
        category:"",
        property_type:"",
        phonenumber:"",
      };

      const [formValues , setFormValues] = useState (intailvalues);
      const [isSubmit , setIsSubmit] = useState ({});
      const form = useRef ();
      const [formErrors, setFormErrors] = useState(false);
      
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({...formValues,[name]:value});
      }
    
      const handleSubmit = (e) => {
        e.preventDefault ();
        console.log(formValues)
        setIsSubmit(true)
        setFormErrors(validate(formValues)); 
      }

      useEffect(() => {
        // console.log(formErrors);
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            // console.log(formValues);
        }
      });
    

      const validate = (values) => {
        let errors ="";

        if(!values.service || !values.category || !values.property_type || !values.phonenumber) {
            errors = "Please Fill the Mandatory Fields"

            // if(!values.phonenumber.length !==10){
            //     errors = "invalid Phone Number"
            // }
        }
            // if (!values.phonenumber) {
            //   errors.phonenumber = "Phone Number is Requried";
            // } else if (isNaN(values.phonenumber)) {
            //   errors.phonenumber = "Invalid Phone Number";
            // } else if (values.phonenumber.length !== 10) {
            //   errors.phonenumber = "Invalid Phone Number";
            // }
        
       
        return errors;
      }

      
       
    return (
    <>
        <div className="post_property_banner py-20 px-6">
            <div className="max-w-[1240px] mx-auto flex flex-wrap justify-between">

                <div className="mx-auto xl:mx-0">
                    <h1 className="font-[merriweather] text-[42px] text-[#17212B] font-[400] leading-[45px] md:text-[52px]">Sell or Rent Your Property</h1>
                    <div className="flex mt-6">
                        <img className="w-[14px] h-[12px] my-auto" src={vector} alt="check mark"/>
                        <h3 className="font-[lato] text-[21px] text-[#363537] ml-[17px]">Get unlimited enquiries </h3>
                    </div>
                    <div className="flex my-2">
                        <img className="w-[14px] h-[12px] my-auto" src={vector} alt="check mark"/>
                        <h3 className="font-[lato] text-[21px] text-[#363537] ml-[17px]">Get Shortlisted buyer & Tenants</h3>
                    </div>
                    <div className="flex my-2">
                        <img className="w-[14px] h-[12px] my-auto" src={vector} alt="check mark"/>
                        <h3 className="font-[lato] text-[21px] text-[#363537] ml-[17px]">Assistance in co-ordinating site visits  </h3>
                    </div>
                </div>

                {/* form */}
                <div className="w-[422px] h-fit bg-white rounded-[14px] font-[lato] text-[#363537] p-[23px] mx-auto mt-16 xl:mx-0 xl:mt-0" data-aos="fade-up">
                    <h1 className="text-[26px] font-[700] leading-[28px]">Start posting your property</h1>
                    
                    <form ref={form} onSubmit={handleSubmit}>

                        <p className="mt-[37px] font-[700] text-[15.317px] leading-[16.716px]">You’ are looking to...</p>

                        <div className="flex mt-[15px]">    
                            <label className="relative">
                                <input className="w-[91px] h-[34px]" type="radio" name="service" value="Sell" onChange={handleChange}/>
                                <p className="absolute inset-0 top-1.5 left-7 font-brown text-[14px]">Sell</p>
                            </label>
                            <label className="relative ml-[11px]">
                                <input className="w-[127px] h-[34px]" type="radio" name="service" value="Rent/Lease" onChange={handleChange}/>
                                <p className="absolute inset-0 top-1.5 left-7 font-brown text-[14px]">Rent/Lease</p>
                            </label>
                        </div>

                        <p className="my-[21px] font-[700] text-[15.317px] leading-[16.716px]">And it’s a ...</p>

                        <div className="flex mt-[20px]">  
                            <input className="w-[17px] h-[17px] my-auto" type="radio" name="category" value="Residential" onChange={handleChange}/>
                            <p className="font-brown text-[15.317px] ml-[7px] my-auto">Residential</p>

                            <input className="w-[17px] h-[17px] my-auto ml-9" type="radio" name="category" value="Commercial" onChange={handleChange}/>
                            <p className="font-brown text-[15.317px] ml-[7px] my-auto">Commercial</p>
                        </div>

                        <div className="mt-[18px]">  
                            <label className="relative">
                                <input className="w-[134px] h-[35px]" type="radio" name="property_type" value="Flat / Apartment" onChange={handleChange}/>
                                <p className="absolute inset-0 -top-3 left-5 font-brown text-[14px]">Flat / Apartment</p>
                            </label>
                            <label className="relative mt-6 md:ml-[11px]">
                                <input className="w-[196px] h-[35px]" type="radio" name="property_type" value="Independent house / villa" onChange={handleChange}/>
                                <p className="absolute inset-0 -top-3 left-5 font-brown text-[14px]">Independent House / Villa </p>
                            </label>
                        </div>

                        <div className="mt-[7px]">
                            <label className="relative ">
                                <input className="w-[134px] h-[34px]" type="radio" name="property_type" value="Farmhouse" onChange={handleChange}/>
                                <p className="absolute inset-0 -top-3 left-7 font-brown text-[14px]">Farmhouse </p>
                            </label>
                            <label className="relative ml-[11px]">
                                <input className="w-[124px] h-[34px]" type="radio" name="property_type" value="plot/Land" onChange={handleChange}/>
                                <p className="absolute inset-0 -top-3 left-7 font-brown text-[14px]">Plot / Land</p>
                            </label>
                        </div>

                        <p className="mt-[26px] font-[700] text-[17px] leading-[16.716px] md:mt-[36px] lg:mt-[45px]">Your contact details for the buyer to reach you</p>
                        
                        <input className="w-full h-[52px] border border-[#D1D4D6] rounded-[4px] mt-[13px] pl-4 placeholder:text-[#CBC7CF] outline-0 focus:border focus:border-[#FFE000]" type="number" placeholder="Phone number" name="phonenumber" onChange={handleChange}/>
                        <p className="mt-[10px] font-[400] text-[13px] leading-[16.716px]">Are you a registered user? Login</p>
                        
                        <div className="my-4 text-center">
                            {formErrors && <p className="error-msg ease-in-out duration-300">{formErrors}</p>}
                        </div>
                        <input className="mt-[20px] mb-[10px]  py-4 w-full bg-yellow uppercase font-[lato] text-[16px] font-[500] leading-[16px] tracking-[1.40px]" type="submit" value="Start now"/>

                    </form>
                </div>

            </div>
        </div>
        

        <div className="my-16">
            <h3 className="font-[lato] text-brown text-[20px] text-center" data-aos="fade-up">How to Post</h3>
            <h1 className="font-[merriweather] text-hblack text-[52px] leading-[65px] text-center mt-2 px-2 lg:px-0" data-aos="fade-up">Post your property in <br/> 3 Simple Steps</h1>
        </div>

        <div className="max-w-[1200px] mx-auto my-16 flex flex-wrap justify-center lg:my-32">
            <div className="max-w-[340px] mx-auto mt-16 lg:mt-0" data-aos="fade-up">
                <img className="w-[80px] mx-auto" src={property_address} alt="property address" />
                <h2 className="font-[lato] font-medium text-[22px] leading-[30px] mt-16">01. Add details of your property</h2>
                <p className="font-[lato] text-font-grey text-[15px] leading-[22px] mt-4">Begin by telling us the few basic details about your property like your property type, location, No. of rooms etc</p>
            </div>
            <div className="max-w-[340px] mx-auto mt-16 lg:mt-0" data-aos="fade-up">
                <img className="w-[80px] mx-auto" src={property_photos} alt="property address" />
                <h2 className="font-[lato] font-medium text-[22px] leading-[30px] mt-[73px]">02. Upload Photos & Videos</h2>
                <p className="font-[lato] text-font-grey text-[15px] leading-[22px] mt-4">Upload photos and videos of your property either via your desktop device or from your mobile phone</p>
            </div>
            <div className="max-w-[340px] mx-auto mt-16 lg:mt-0" data-aos="fade-up">
                <img className="w-[80px] mx-auto" src={property_pricing} alt="property address" />
                <h2 className="font-[lato] font-medium text-[22px] leading-[30px] mt-14">03. Add Pricing & Ownership</h2>
                <p className="font-[lato] text-font-grey text-[15px] leading-[22px] mt-4">Just update your property’s ownership details and your expeced price and your property is ready for posting</p>
            </div>
        </div>

        <Chatus />

        {/* <FAQ /> */}
    </>
    );
}

export default PostProperty;
